import { Box, Column, Text } from '~/commonComponents';
import { IEducationSlideItem } from './Types';
import { Colors } from '~/themes/colors';

interface ISlideItemProps {
  item: IEducationSlideItem;
}

export const SlideItem = ({ item }: ISlideItemProps) => (
  <Column alignItems="center" gap={16} justifyContent="center" paddingInline={36}>
    <Box width={220} height={165}>
      <img
        src={item.Illustration}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        alt={`EducationIllustration-${item.title}`}
      />
    </Box>
    <Text bold color={Colors.primary_500} fontSize={20} textAlign="center">
      {item.title}
    </Text>
    <Text color={Colors.neutral_500} textAlign="center">
      {item.description}
    </Text>
  </Column>
);
